import { c as _c } from "react/compiler-runtime";
interface StarRatingProps {
  rating: number;
  className?: string;
}
const STAR_PATH = "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z";
const StarIcon = t0 => {
  const $ = _c(3);
  const {
    filled
  } = t0;
  const t1 = filled ? "fill-yellow-m10" : "fill-none stroke-yellow-m10";
  const t2 = filled ? 0 : 1.5;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0" aria-hidden="true" focusable="false"><path d={STAR_PATH} className={t1} strokeWidth={t2} /></svg>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export const StarRating = t0 => {
  const $ = _c(10);
  const {
    rating,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const clampedRating = Math.min(5, Math.max(0, Math.round(rating * 2) / 2));
  const fillPercent = clampedRating / 5 * 100;
  const t2 = `relative inline-flex gap-0.5 ${className}`;
  const t3 = `${clampedRating} out of 5 stars`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex gap-0.5" aria-hidden="true">{Array.from({
        length: 5
      }).map(_temp)}</div>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = `${fillPercent}%`;
  let t6;
  if ($[1] !== t5) {
    t6 = {
      width: t5
    };
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = Array.from({
      length: 5
    }).map(_temp2);
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t6) {
    t8 = <div className="absolute inset-0 flex gap-0.5 overflow-hidden" style={t6} aria-hidden="true">{t7}</div>;
    $[4] = t6;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t8) {
    t9 = <div className={t2} role="img" aria-label={t3} data-testid="testimonial-rating">{t4}{t8}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};
function _temp(_, index) {
  return <StarIcon key={`empty-${index}`} filled={false} />;
}
function _temp2(__0, index_0) {
  return <StarIcon key={`filled-${index_0}`} filled={true} />;
}